// Journal-Seite (Redesign Schritt 5, Spec 4.3): Ablage · Journal · Auswertung
import { useState } from "react";
import { SubTabs, useSubTab } from "../shell/SubTabs";
import ErrorBoundary from "../components/ErrorBoundary";
import AblageTab, { useAblage } from "../journal/AblageTab";
import JournalTab from "../journal/JournalTab";
import AuswertungTab from "../journal/AuswertungTab";

const KEYS = ["ablage", "journal", "auswertung"] as const;

export default function JournalHub() {
  const [tab, setTab] = useSubTab(KEYS, "journal");
  const { data: ablage = [] } = useAblage();
  const [taken, setTaken] = useState<string | null>(null);
  return (
    <>
      <SubTabs value={tab} onChange={setTab} tabs={[
        { key: "ablage", label: ablage.length ? `Ablage · ${ablage.length}` : "Ablage" },
        { key: "journal", label: "Journal" },
        { key: "auswertung", label: "Auswertung" },
      ]} />
      {taken && tab === "journal" && <div className="sc-toast" role="status"><span>{taken}</span>
        <button onClick={() => setTaken(null)}>OK</button></div>}
      <ErrorBoundary key={tab}>
        {tab === "ablage" && <AblageTab onTaken={n => { setTaken(`${n} ins Journal übernommen. Produkt und Einstieg kannst du jetzt ergänzen.`); setTab("journal"); }} />}
        {tab === "journal" && <JournalTab />}
        {tab === "auswertung" && <AuswertungTab />}
      </ErrorBoundary>
    </>
  );
}
